var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.type && _vm.duration && (_vm.instrument || _vm.event)
    ? _c("SoliAvatarBtn", {
        attrs: {
          blue: "",
          icon: _vm.event ? "diversity_3" : "music_note",
          title: _vm.lessonTitle,
          subtitleTop: _vm.dateTime,
          subtitleBottom: _vm.reschedule_pass
            ? "1 pass available"
            : `${_vm.reschedule_minutes} minutes available`,
        },
        on: {
          click: function ($event) {
            return _vm.$emit("input", _vm.event)
          },
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }